module.exports = __webpack_public_path__ + "fonts/Gilroy-Semibold.e4a3d05f.woff2";